// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  padding-bottom: clamp(5rem, 12vw, 8rem);
}

.contact__inner {
  display: grid;
  grid-template-columns: 0.9fr 1.1fr;
  gap: clamp(2rem, 6vw, 4.5rem);
  align-items: start;
}

.contact__note {
  margin-top: 1.5rem;
  color: var(--ink-soft);
  font-weight: 500;
}

.contact__form {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem 1.1rem;
  padding: clamp(1.25rem, 3vw, 1.75rem);
  background:
    linear-gradient(160deg, rgba(255, 255, 255, 0.72), rgba(243, 239, 230, 0.9)),
    var(--paper);
  border: 1px solid var(--line);
  border-radius: 6px;
}

.field {
  display: grid;
  gap: 0.45rem;
}

.field--full {
  grid-column: 1 / -1;
}

.field span {
  font-size: 0.9rem;
  font-weight: 600;
  color: var(--ink);
}

.field input,
.field textarea {
  width: 100%;
  padding: 0.85rem 0.95rem;
  border: 1px solid rgba(15, 46, 36, 0.16);
  border-radius: var(--radius);
  background: rgba(255, 255, 255, 0.8);
  color: var(--text);
  outline: none;
  transition:
    border-color 0.2s ease,
    box-shadow 0.2s ease,
    background-color 0.2s ease;
}

.field input::placeholder,
.field textarea::placeholder {
  color: #8a9a92;
}

.field input:focus,
.field textarea:focus {
  border-color: var(--moss);
  background: #fff;
  box-shadow: 0 0 0 3px rgba(47, 107, 82, 0.12);
}

.field textarea {
  resize: vertical;
  min-height: 120px;
}

.contact__actions {
  grid-column: 1 / -1;
  display: grid;
  gap: 0.75rem;
  margin-top: 0.35rem;
}

.contact__actions .btn {
  justify-self: start;
}

.contact__hint {
  margin: -0.25rem 0 0;
  font-size: 0.88rem;
  color: var(--muted);
}

.contact__privacy {
  max-width: 42ch;
  font-size: 0.85rem;
  color: var(--muted);
}

.field input[aria-invalid='true'] {
  border-color: rgba(180, 35, 24, 0.45);
}

.contact__status {
  grid-column: 1 / -1;
  margin: 0.25rem 0 0;
  font-weight: 500;
}

.contact__status--ok {
  color: var(--moss);
}

.contact__status--err {
  color: var(--danger);
}

@media (max-width: 860px) {
  .contact__inner {
    grid-template-columns: 1fr;
  }
}

@media (max-width: 560px) {
  .contact__form {
    grid-template-columns: 1fr;
  }

  .contact__actions .btn {
    width: 100%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/LeadForm.css"],"names":[],"mappings":"AAAA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;EAChB,qCAAqC;EACrC;;gBAEc;EACd,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;EAEE,WAAW;EACX,wBAAwB;EACxB,wCAAwC;EACxC,4BAA4B;EAC5B,oCAAoC;EACpC,kBAAkB;EAClB,aAAa;EACb;;;8BAG4B;AAC9B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,yBAAyB;EACzB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":[".contact {\r\n  padding-bottom: clamp(5rem, 12vw, 8rem);\r\n}\r\n\r\n.contact__inner {\r\n  display: grid;\r\n  grid-template-columns: 0.9fr 1.1fr;\r\n  gap: clamp(2rem, 6vw, 4.5rem);\r\n  align-items: start;\r\n}\r\n\r\n.contact__note {\r\n  margin-top: 1.5rem;\r\n  color: var(--ink-soft);\r\n  font-weight: 500;\r\n}\r\n\r\n.contact__form {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 1rem 1.1rem;\r\n  padding: clamp(1.25rem, 3vw, 1.75rem);\r\n  background:\r\n    linear-gradient(160deg, rgba(255, 255, 255, 0.72), rgba(243, 239, 230, 0.9)),\r\n    var(--paper);\r\n  border: 1px solid var(--line);\r\n  border-radius: 6px;\r\n}\r\n\r\n.field {\r\n  display: grid;\r\n  gap: 0.45rem;\r\n}\r\n\r\n.field--full {\r\n  grid-column: 1 / -1;\r\n}\r\n\r\n.field span {\r\n  font-size: 0.9rem;\r\n  font-weight: 600;\r\n  color: var(--ink);\r\n}\r\n\r\n.field input,\r\n.field textarea {\r\n  width: 100%;\r\n  padding: 0.85rem 0.95rem;\r\n  border: 1px solid rgba(15, 46, 36, 0.16);\r\n  border-radius: var(--radius);\r\n  background: rgba(255, 255, 255, 0.8);\r\n  color: var(--text);\r\n  outline: none;\r\n  transition:\r\n    border-color 0.2s ease,\r\n    box-shadow 0.2s ease,\r\n    background-color 0.2s ease;\r\n}\r\n\r\n.field input::placeholder,\r\n.field textarea::placeholder {\r\n  color: #8a9a92;\r\n}\r\n\r\n.field input:focus,\r\n.field textarea:focus {\r\n  border-color: var(--moss);\r\n  background: #fff;\r\n  box-shadow: 0 0 0 3px rgba(47, 107, 82, 0.12);\r\n}\r\n\r\n.field textarea {\r\n  resize: vertical;\r\n  min-height: 120px;\r\n}\r\n\r\n.contact__actions {\r\n  grid-column: 1 / -1;\r\n  display: grid;\r\n  gap: 0.75rem;\r\n  margin-top: 0.35rem;\r\n}\r\n\r\n.contact__actions .btn {\r\n  justify-self: start;\r\n}\r\n\r\n.contact__hint {\r\n  margin: -0.25rem 0 0;\r\n  font-size: 0.88rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.contact__privacy {\r\n  max-width: 42ch;\r\n  font-size: 0.85rem;\r\n  color: var(--muted);\r\n}\r\n\r\n.field input[aria-invalid='true'] {\r\n  border-color: rgba(180, 35, 24, 0.45);\r\n}\r\n\r\n.contact__status {\r\n  grid-column: 1 / -1;\r\n  margin: 0.25rem 0 0;\r\n  font-weight: 500;\r\n}\r\n\r\n.contact__status--ok {\r\n  color: var(--moss);\r\n}\r\n\r\n.contact__status--err {\r\n  color: var(--danger);\r\n}\r\n\r\n@media (max-width: 860px) {\r\n  .contact__inner {\r\n    grid-template-columns: 1fr;\r\n  }\r\n}\r\n\r\n@media (max-width: 560px) {\r\n  .contact__form {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .contact__actions .btn {\r\n    width: 100%;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
